import { render } from "./PompeTable.vue?vue&type=template&id=1bf209dd&scoped=true"
import script from "./PompeTable.vue?vue&type=script&lang=js"
export * from "./PompeTable.vue?vue&type=script&lang=js"

import "./PompeTable.vue?vue&type=style&index=0&id=1bf209dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf209dd"]])

export default __exports__